import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
	state: {

	},
	mutations: {
	}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js